import axios from 'axios'
import { message } from 'antd'
const baseURL = process.env.NODE_ENV === 'production' ? 'https://teruo-home.gdhttech.com' : 'https://teruo-home.gdhttech.com'
export const updateUrl = baseURL + '/file/upload'
// 文件上传路径
export const uploaddir = '/pkg'
export const ossClientInfo = {
	accessKeyId: 'LTAIIl7U5YXo01VV',
	accessKeySecret: 'ORHg2t7NRpBZMqRCw0OlgIh0nCQ3zP',
	region: 'oss-cn-shenzhen',
	bucket: 'net-ticket',
}
const instance = axios.create({
	baseURL,
	timeout: 30000,
})
// 添加响应拦截器
instance.interceptors.response.use(
	response => {
		return response
	},
	error => {
		message.destroy()
		switch (error.response.status) {
			case 500:
			// 未登录
			case 400:
				message.error(error.response.data || '请求失败', 2)
				break
			case 401:
				message.error(error.response.data, 2, () => {
					if (window._ROUTER_.location.pathname !== '/login') {
						let q = window.location.hash
						q = q.substring(q.indexOf('#') + 1)
						window._ROUTER_.history.push('/login?q=' + encodeURIComponent(q))
					}
				})
				return false
			default:
				message.error('请求失败', 2)
				break
		}
		return Promise.reject(error)
	}
)

function NetData(method, url, params,type,blob) {
	return new Promise((resove, reject = () => { }) => {
		return instance({
			url,
			method,
			responseType: blob ? 'blob' : '',
			headers: {
				'Content-Type': type ? type:'',
				'X-Request-Token': '',
			},
			params: method === 'GET' ? params : null,
			data: method !== 'GET' ? params : null,
		})
			.then(res => {
				if (res.status === 200) {
					resove({ data: res.data, date: res.headers.date })
				}
				else {
					reject(res)
				}
			})
			.catch(error => {
				reject(error)
			})
	})
}

export default {
	get: (url, params = {}) => NetData('GET', url, params),
	post: (url, params = {},type) => NetData('POST', url, params,type),
	baseURL
}